import React, {useEffect, useState} from 'react'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'
import AppBar from '@material-ui/core/AppBar'
import IconButton from "@material-ui/core/IconButton/IconButton";
import { Redirect} from "react-router-dom";
import logo from "../assets/images/logo.png";
import {connect, useDispatch, useSelector} from "react-redux";
import Container from "@material-ui/core/Container/Container";
import MainRouting from "../routes/mainRouting.jsx";
import { useHistory  } from 'react-router-dom'
import {getEstabelecimentos, setEstabelecimento} from "../actions/FilterActions";
import {authLogout} from "../actions/authAction";
import mainPaineisRoutes from "../routes/paineisRotas";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import * as config from "../config";
import {CircularProgress, LinearProgress} from "@material-ui/core";
import useWindowDimensions from "../utils/windowSizeHook";
import HoraLabel from "../components/HoraLabel";
import TituloProgressBar from "../components/TituloProgressBar";
import FiltersSection from "../pages/Filters/FiltersSection";
import FiltersSectionColumn from "../pages/Filters/FiltersSectionColumn";

const appBarBgColor = () => {
  switch (localStorage.getItem('tenantFolder')) {
    case '4':
        return '#C00D0E'

    default:
       return '#D0CACAFF'
  }
}

const useStyles = makeStyles(theme => {


  return ({
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#dee2f4'

  },

  appBar: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    minHeight: '40px',
    maxHeight: '120px',
   // height: '40px'
    backgroundColor: appBarBgColor
  },
  navLogoLkt: {
    height: "40px",
    width: "210px",
    verticalAlign: 'middle',
    margin: '0px'
  },
  navLogo: {
    margin: '0px',
    height: "90x",
    width: "322px",
    verticalAlign: 'middle'
  },
    logoButton: {
      margin: 0,
      borderRadius: '0px !important',
      padding: 0
    },

  mainContentWidth: {
    // width: `calc(100% - ${drawerWidth}px) !important`,
    // marginRight: '0px',
  },
  container: {
    justifyContent: 'center',
    flexWrap: 'nowrap',
    marginTop: '130px',

    display: 'flex',
    height: `calc(100vh - 130px) !important`,
    //  `100vh`
  },




  content: {
    flex: 1,
    borderStyle: 'groove',
    borderColor: 'cadetblue',
    borderWidth: 5,
    padding: theme.spacing(1) * 3,
    left: 'auto'
  },
  rightSide:{
    display: 'flex',
    flexDirection: 'column'

  }

  });
}) ;







const  TelaCheia = (props) => {
  const { isAuthenticated} = props;
  const { height, width } = useWindowDimensions();
  const portrait = height > width;

  const classes = useStyles();
  const history = useHistory();

  const [titulo,setTitulo] = useState('');
  const [progressMax, setProgressMax] = useState(30);
  const [resetTimer, setResetTimer] = useState(true);
  const [tcContador, setTCContador] = useState(0);

  const estabelecimentos = useSelector(state => state.filter.estabelecimentos);
  const dispatch = useDispatch();


  useEffect(()=>{
    dispatch(getEstabelecimentos())
  },[])



    if (!isAuthenticated) {
      console.log("appbase.render.redirectToLogin");
      return (<div><Redirect to="/login"/></div>);
    }





  const cbSetTitulo = (tit) => {
      setTitulo(tit);
    }

    const cbSetTempoLimite = (tempoLimite) => {
      console.log("cbSetTempoLimite. alterado progressMax para ", tempoLimite)
      setProgressMax(tempoLimite);
      setResetTimer(true);
    }



  const setEstabelecimento = (estab) => {
    localStorage.setItem('estabId', estab);
    this.props.setEstabelecimento(estab);
  }

  if ( (estabelecimentos && estabelecimentos.length > 0 && estabelecimentos[0].fake) ||
       !estabelecimentos || (estabelecimentos && estabelecimentos.length === 0)
     ){
    console.log("Estabelecimentos nao carregado, aguardar");
    return (<CircularProgress/>);
  }


  const imglogo = `http://arq-tipler.digama.com.br/images/tnt${config.getTntFolder()}/logoEmpresaBco.png`;


  const onFilterClick = () => {
    setTCContador(tcContador+1);
  }

  const loading = false;


    return (
      <div className={classes.root}>
        <AppBar className={classes.appBar}>
          <Grid container  className={classes.appBar}>
              <Grid item>
                <IconButton onClick={() => history.push('/')} className={classes.logoButton}>
                  <img src={ imglogo} className={classes.navLogo} alt='logo'/>
                </IconButton>
              </Grid>

            <Grid item container style={{ backgroundColor: 'transparent', alignSelf:'center', justifyContent: 'center'}} xs={2} sm={2} md={2} lg={2} xl={2}>
              <Grid item xs={12}>
                <FiltersSectionColumn showPeriod={true} showBeforePeriod={false} showBenchPeriod={false} onFilterClick={onFilterClick} loading={loading}  />
              </Grid>
            </Grid>

              <Grid item container style={{alignSelf:'center', justifyContent: 'center'}}>
                <Grid item container style={{  alignSelf:'center', justifyContent: 'center'}} >
                  <Grid item>
                      <Typography variant="h4" style={{fontSize:'3rem'}}>{titulo}</Typography>
                    <TituloProgressBar  titulo={titulo} limite={progressMax}/>
                    {/*<Typography variant="subtitle1" style={{fontSize: '0.7rem'}}>{height} x {width}</Typography>*/}
                  </Grid>
                </Grid>

              </Grid>

            { !portrait &&
              <Grid item style={{marginRight:'20px', alignSelf:'center'}}>
                <Grid container className={classes.rightSide} >
                  <Grid item style={{marginRight:'30px', alignSelf:'flex-end'}}>
                      <HoraLabel/>
                  </Grid>
                  <Grid item style={{margin:0, marginBottom: '5px'}} xs={1} sm={1} md={1} lg={1} xl={1} >

                      {/*<img src={logo} className={classes.navLogoLkt} alt='logo'/>*/}

                  </Grid>
                </Grid>
              </Grid>
            }
          </Grid>
        </AppBar>

          <Container id="mainContent" maxWidth="xl" className={classNames(classes.container)}>
                <MainRouting grupo="paineisRotas" tcContador={tcContador} grupoRotas={mainPaineisRoutes} setTitulo={cbSetTitulo} setLimite={cbSetTempoLimite}/>
          </Container>
      </div>
    )

}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.id !== null && (state.auth.expiresIn * 1000 > new Date().getTime()),
    auth: state.auth,
    error: state.filter.error,
    estabelecimentos: state.filter.estabelecimentos,
    estabalecimentosLoading: state.filter.estabalecimentosLoading,
    estabelecimentoId: state.filter.estabelecimentoId
  }
}

export default connect(mapStateToProps,{getEstabelecimentos, setEstabelecimento, authLogout})(TelaCheia)
